export default "__VITE_ASSET__U6OAjP9r__"